export const GET_ALL_EVENT = 'GET_ALL_EVENT';
export const CREATE_EVENT = 'CREATE_EVENT';
export const GET_DETAIL = 'GET_DETAIL';
export const FILTER_GET_EVENTS = "FILTER_GET_EVENTS";
export const MODAL = 'MODAL'
export const POST_LOGIN = 'POST_LOGIN';
export const LOG_OUT = 'LOG_OUT';
export const GET_MY_EVENTS = 'GET_MY_EVENTS';
export const PUT_EVENT = 'PUT_EVENT';
export const ORDER_PAY = 'ORDER_PAY';
export const GET_MY_SALES = 'GET_MY_SALES';
export const ADD_CAR = 'ADD_CAR';
export const ADD_TO_CAR = 'ADD_TO_CAR'
export const GET_EVENTS_ADMIN = 'GET_EVENTS_ADMIN'
export const DELETE_EVENT_CAR = 'DELETE_EVENT_CAR'
export const POST_REVIEW= "POST_REVIEW"
export const PUT_PROFILE= "PUT_PROFILE"
export const SEARCH_EVENT_ADMIN= "SEARCH_EVENT_ADMIN"
